<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="sa_code,sa_custname,sa_remark"
      placeholder="输入单据编号、客户、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/sale/order/' + item.sa_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.sa_custname}}</p>
          <p class="list-item-muted">{{item.sa_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'" v-if="!isFieldHidden('main.sa_total')">{{item.sa_total}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.sa_sendstatus!='已出库'}"
          >{{item.sa_sendstatus}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'" v-if="!isFieldHidden('main.sa_total')">{{getTotal('sa_total')}}</em>
    </div>
    <add-button to="/sale/order_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import listCustomization from "@/mixins/listCustomization.js";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list,listCustomization],
  data() {
    return {
      params: {
        caller: 'Sale',
        name: 'sale-sale-querypanel-MAIN', 
      },
      listUrl: "/api/sale/sale/list",
      filters: [
        {
          type: "date",
          name: "sa_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待发货",
              condition:
                "sa_status='已审核' and IFNULL(sd_bussStatuscode,' ')<>'CLOSE' and sd_qty>IFNULL(sd_sendqty,0) and sd_qty>IFNULL(sd_yqty,0)",
              mode: "DETAIL"
            },
            {
              value: 2,
              label: "待对账",
              condition:
                "sa_status='已审核' and ifnull(sd_sendqty,0) > ifnull(sd_checkqty,0)",
              mode: "DETAIL"
            },
            {
              value: 3,
              label: "待收款",
              condition: "sa_status='已审核' and ifnull(sa_recbalance,0)>0"
            },
            {
              value: 4,
              label: "已出货",
              condition: "IFNULL(sd_sendqty,0)>0",
              mode: "DETAIL"
            },
            {
              value: 5,
              label: "已取消",
              condition: "IFNULL(sd_bussStatuscode,' ')='CLOSE'",
              mode: "DETAIL"
            }
          ]
        }
      ]
    };
  }
};
</script>